import PropTypes from "prop-types";

// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";

// MUI
import { Stack } from "@mui/material";

export default function MatrixRow(props) {
	const {
		index = 0,
		item = null,
		fromDisabled = false,
		toDisabled = false,
		bonusInputData = [
			{
				type: "Percent",
				min: -100,
				max: 100,
				decimalsEditable: true,
				decimals: 2,
			},
			{
				type: "Dollar",
				min: -50000,
				max: 50000,
				decimalsEditable: true,
				decimals: 2,
			},
		],
		spaces = {
			mainSection: 100,
			columns: 100,
			totalColumns: 1,
			totalRows: 1,
			separation: 5.5,
		},
		rowsErrors = [],
		columnsErrors = [],
		readOnly = false,
		spacing = 0.8,
		mainContentProps = null,
		sxMainContent = {
			minWidth: "190px",
		},
		cellsProps = {
			justifyContent: "center",
			alignItems: "center",
		},
		sxCells = {
			minWidth: "100px",
		},
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	const hasOneBonusOnly = spaces?.totalColumns === 1 && spaces?.totalRows === 1;

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: [
								{
									type: "Dollar",
									min: 0,
									max: 100000000,
									decimals: 2,
									decimalsEditable: false,
									delta: 0.01,
									dashed: fromDisabled,
								},
							],
							sx: { width: "106px" },
							defaultType: item?.from?.input || "Dollar",
							value: item?.from?.value || 0,
							error: Boolean(rowsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
						}}
						secondInput={{
							data: [
								{
									type: "Dollar",
									min: 0,
									max: 100000000,
									decimals: 2,
									decimalsEditable: false,
									delta: 0.01,
									dashed: toDisabled,
								},
							],
							sx: { width: "106px" },
							defaultType: item?.to?.type || "Dollar",
							value: item?.to?.value || 0,
							error: Boolean(rowsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, 0, "row", "to", value);
							},
							readOnly,
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.bonuses?.map((element, key) => {
						const indexKey = `bonuses_input_${key}`;
						return (
							<Stack key={indexKey} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={bonusInputData}
									value={element?.bonus?.value || 0}
									defaultType={element?.bonus?.input || "Percent"}
									error={Boolean(columnsErrors?.[index]?.[key]?.["bonus"])}
									disabled={readOnly || hasOneBonusOnly}
									readOnly={readOnly || hasOneBonusOnly}
									onChangeType={(_, input) => {
										onChangeType?.(index, key, "row", "bonus", input);
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.(index, key, "row", "bonus", value);
									}}
									sx={{
										width: "95px",
									}}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
}
MatrixRow.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	bonusInputData: PropTypes.array,
	spaces: PropTypes.object,
	rowsErrors: PropTypes.array,
	columnsErrors: PropTypes.array,
	readOnly: PropTypes.bool,
	spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	mainContentProps: PropTypes.object,
	sxMainContent: PropTypes.object,
	cellsProps: PropTypes.object,
	sxCells: PropTypes.object,
	onChangeType: PropTypes.func,
	onActionUpdate: PropTypes.func,
};
